import { useSelector } from 'react-redux';
import { ILocation } from '../../../entities/general.entities';
import { translate } from '../../../lib/lang.helper';
import Input from '../input/Input';
import { selectLang } from '../../../store/ui/ui.selector';
import { Button, Modal } from 'antd';
import { useState } from 'react';
import { Map } from '..';
import { IFarmResource } from '../../../entities/farms.entities';

const defaultCenter = {
  lat: -41.0917585,
  lng: 173.828391,
};

interface IPoint {
  lat: number | null;
  lng: number | null;
}

interface Props {
  farmData?: IFarmResource;
  className?: string;
  points: IPoint[];
  onChange: (points: IPoint[]) => void;
}

const SectionLocationForm = ({
  farmData,
  className,
  points,
  onChange,
}: Props) => {
  const lang = useSelector(selectLang);

  const [visible, setVisible] = useState(false);
  const [mapPoints, setMapPoints] = useState<ILocation[]>([]);

  const updatePoint = (index: number, field: 'lat' | 'lng', value: string) => {
    const newPoints = [...points];
    const val = value.length <= 0 ? null : Number(value);
    newPoints[index] = {
      ...newPoints[index],
      [field]: val,
    };
    onChange(newPoints.map(p => ({ lat: p.lat || 0, lng: p.lng || 0 })));
  };
  const clickLocation = (lc: ILocation) => {
    if (mapPoints.length >= 4) {
      return;
    }
    setMapPoints([...mapPoints, lc]);
  };
  const confirmMap = () => {
    if (mapPoints.length < 4) {
      Modal.error({
        title: translate(lang, 'Error'),
        content: translate(lang, '_sel_points_map'),
      });
      return;
    }
    onChange(mapPoints);
    setVisible(false);
  };

  const center =
    farmData && farmData.bounds && farmData.bounds.length > 0
      ? farmData.bounds[0]
      : defaultCenter;

  return (
    <div className={`${className} table--small`}>
      {[0, 1, 2, 3].map(idx => (
        <div key={idx} className='w-100 d-flex mb-12'>
          <div className='mr-12 flex-1'>
            <Input
              type='number'
              label={translate(lang, 'Point %s Latitude', idx + 1)}
              value={
                points.length > idx ? points[idx].lat?.toString() || '' : ''
              }
              onChange={e => updatePoint(idx, 'lat', e.target.value)}
            />
          </div>
          <div className='ml-12 flex-1'>
            <Input
              type='number'
              label={translate(lang, 'Point %s Longitude', idx + 1)}
              value={
                points.length > idx ? points[idx].lng?.toString() || '' : ''
              }
              onChange={e => updatePoint(idx, 'lng', e.target.value)}
            />
          </div>
        </div>
      ))}
      <div className='mt-12'>
        <Button
          type='primary'
          onClick={() => {
            setMapPoints([]);
            setVisible(true);
          }}
        >
          {translate(lang, '_pickup_location_map')}
        </Button>
      </div>
      {visible && (
        <Modal
          visible={true}
          width={1200}
          closable
          onCancel={() => setVisible(false)}
          footer={null}
        >
          <div className='mb-16' style={{ height: '600px' }}>
            <Map
              zoom={15}
              defaultPosition={
                (points.find(x => x.lat && x.lng) as ILocation | undefined) ??
                center
              }
              polygons={[mapPoints]}
              onCallback={pt => clickLocation(pt)}
              isStayLocation={true}
              hideMarker={true}
            />
          </div>
          <div className='d-flex justify-end'>
            <div className='mr-12'>
              <Button
                type='primary'
                danger={true}
                onClick={() => setVisible(false)}
              >
                {translate(lang, 'Cancel')}
              </Button>
            </div>
            <div className='ml-12'>
              <Button type='primary' onClick={confirmMap}>
                {translate(lang, 'Confirm')}
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default SectionLocationForm;
